import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Box, Grid, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const SecretComponent = () => {
  const [token, setToken] = useState('');
  const [secret, setSecret] = useState('');
  const [generatedURL, setGeneratedURL] = useState('');
  const [revealedSecret, setRevealedSecret] = useState('');
  const [URLIsGenerated, setURLIsGenerated] = useState(false);
  // Dialog state
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogMessage, setDialogMessage] = useState('');

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    setToken(queryParams.get('token'));
  }, []);

  useEffect(() => {
    if (token) {
      fetch(`https://secret.soliman.nl/api/get/${token}`)
        .then(response => response.json())
        .then(data => {
          if (data.error) {
            setRevealedSecret(data.error);
          } else {
            setRevealedSecret(data.secret);
          }
        })
        .catch(error => {
          setRevealedSecret('An error occurred while fetching the secret.');
        });
    }
  }, [token]);

  const handleSecretChange = (event) => {
    setSecret(event.target.value);
  };

  const generateURL = () => {
    fetch('https://secret.soliman.nl/api/create', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ secret }),
    })
      .then(response => response.json())
      .then(data => {
        const urlWithToken = `https://secret.soliman.nl?token=${data.token}`;
        setGeneratedURL(urlWithToken);
        setURLIsGenerated(true);
      });
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(generatedURL).then(() => {
      // Replace alert with dialog
      showDialog('Copy to Clipboard', 'URL copied to clipboard!');
    });
  };

  const showAbout = () => {    
    let msg = "This site allows you to share secrets through a one-time URL. ";
    msg += "Your secret will be encrypted and stored in a database with a timestamp, but without any further associated metadata.";
    msg += "Your secret can only be accessed once using the generated link.";
    msg += "After visiting the generated link, your secret will immediately be deleted from the database. ";
    showDialog("About", msg);
  }

  const showDisclaimer = () => {    
    let msg = "This site is intended for one-time, secure sharing purposes. It is not suitable for storing information long-term or for sharing non-encrypted personal or highly sensitive information. ";
    msg += "This site is not responsible for the loss or compromise of secrets once they are shared, especially if the generated URL is accessed by unintended recipients.";
    showDialog("Disclaimer", msg);
  }

  const showDialog = (title, message) => {
    setDialogTitle(title);
    setDialogMessage(message);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleRestart = () => {
    setURLIsGenerated(false);
    setGeneratedURL(false);
    setSecret('');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        textAlign: 'center',
      }}
    >
            {token && revealedSecret ? (
        <>
          <TextField
            label="One-time secret"
            variant="outlined"
            value={revealedSecret}
            fullWidth
            sx={{ maxWidth: '500px' }}
          />
          <br />
          <Typography variant='body2'>
            <b>Warning!</b> Take a note of this secret! <br /> This link works only once. The secret will be lost forever and cannot be recovered.<br />
            <a href="https://secret.soliman.nl">Generate your own link here</a>
          </Typography>
        </>
      ) : (
        <>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Enter your secret below and click "Generate URL" to create a secure, one-time link. <br />
            Click on "Copy link to clipboard" to copy the link to your clipboard. <br />
            Tip: never include links, e-mail addresses or usernames.
          </Typography>
          <TextField
            label="Enter your secret"
            variant="outlined"
            value={secret}
            onChange={handleSecretChange}
            fullWidth
            sx={{ maxWidth: '500px' }}
          />
          <Box mt={2} display="flex" justifyContent="center">
            <Grid container spacing={2} justifyContent="center">

              {URLIsGenerated ? (

                <>

                <Grid item>                
                    <Button color="success" variant="contained" onClick={copyToClipboard}>
                      Copy link to clipboard
                    </Button>              
                </Grid>

                <Grid item>                
                  <Button color="warning" variant="contained" onClick={handleRestart}>
                    Restart
                  </Button>              
                </Grid>

                </>

              ) : (

                <Grid item>
                  <Button color="success" variant="contained" onClick={generateURL}>
                    Generate URL
                  </Button>
                </Grid>

              )}

              <Grid item>
                <Button variant="contained" onClick={showAbout}>
                  About
                </Button>
              </Grid>

              <Grid item>
                <Button variant="contained" onClick={showDisclaimer}>
                  Disclaimer
                </Button>
              </Grid>

            </Grid>
          </Box>
          {generatedURL && (
            <Typography variant="body2" sx={{ mt: 2 }}>
              (Generated URL: <a href={generatedURL}>{generatedURL}</a>)
            </Typography>
          )}          
        </>
      )}
      <Typography variant="body2" sx={{ mt: 2 }}>
            This is an ad- and cookie-free tool.
        </Typography>

      {/* Dialog component */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>OK</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SecretComponent;
